export let texts = [
    {
        "id": "ab-testing",
        "name":"A/B Testing",
        "title": "A/B Testing ",
        "body": `
            You can create A / B tests with the help of the Logic Flows. Simply place a
            logic operator <span class="mdi mdi-rhombus-outline"> on the canvas and add a wire from the
            source widget that should trigger the screen transition. Afterwards select the logic
            operator and tick the <strong>A/B Test</strong> checkbox. Now wire the traget screens. During a
            test the operator will send the users randomly along one of the links.
        `,
        "video": {
            "src": "https://www.youtube.com/embed/0DCUbyaG1Qw"
        }
    }
]